var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGoogleIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 38,
  height: 38,
  viewBox: "0 0 38 38",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0.690415 0.585642C0.265004 1.03627 0.015625 1.73402 0.015625 2.62074V34.7752C0.015625 35.6765 0.265004 36.3742 0.690415 36.8103L0.793102 36.9121L18.9684 18.916V18.698V18.4799L0.793102 0.483887L0.690415 0.585642Z",
  fill: "url(#svg-public/img/nestleLanding/Google_Icon.svg__paint0_linear_976_15805)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.0311 24.91L18.9727 18.9064V18.6884V18.4703L25.0311 12.4668L25.1631 12.5395L32.3364 16.5806C34.3902 17.729 34.3902 19.6187 32.3364 20.7816L25.1631 24.8227L25.0311 24.91Z",
  fill: "url(#svg-public/img/nestleLanding/Google_Icon.svg__paint1_linear_976_15805)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M25.1599 24.8374L18.9694 18.6885L0.691406 36.8008C1.3662 37.5131 2.48107 37.6003 3.74263 36.888L25.1599 24.8374Z",
  fill: "url(#svg-public/img/nestleLanding/Google_Icon.svg__paint2_linear_976_15805)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M25.1589 12.5578L3.72701 0.492601C2.46544 -0.219683 1.35057 -0.132464 0.675781 0.579819L18.9685 18.6922L25.1589 12.5578Z",
  fill: "url(#svg-public/img/nestleLanding/Google_Icon.svg__paint3_linear_976_15805)"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M25.0279 24.6921L3.72796 36.6847C2.53975 37.3533 1.46888 37.3097 0.794093 36.6992L0.691406 36.801L0.794093 36.9027C1.48355 37.5132 2.53975 37.5569 3.72796 36.8882L25.1599 24.823L25.0279 24.6921Z",
  fill: "#1A1A1A"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.12,
  d: "M0.690201 36.5999C0.264925 36.1495 0.015625 35.4519 0.015625 34.5655V34.7835C0.015625 35.6844 0.264925 36.382 0.690201 36.8179L0.792855 36.7162L0.690201 36.5999Z",
  fill: "#1A1A1A"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.12,
  d: "M32.3317 20.5782L25.0117 24.692L25.1437 24.8228L32.3171 20.7817C33.3439 20.2003 33.8573 19.4444 33.8573 18.6885C33.784 19.3717 33.2706 20.0549 32.3317 20.5782Z",
  fill: "#1A1A1A"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.25,
  d: "M3.72602 0.69724L32.3313 16.8036C33.2554 17.3269 33.7835 17.9956 33.8715 18.6933C33.8715 17.9374 33.3581 17.167 32.3313 16.6001L3.72602 0.493731C1.67231 -0.654644 0 0.304758 0 2.63058V2.84863C0 0.508268 1.68698 -0.451135 3.72602 0.69724Z",
  fill: "white"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg-public/img/nestleLanding/Google_Icon.svg__paint0_linear_976_15805",
  x1: 17.3542,
  y1: 2.28611,
  x2: -7.04033,
  y2: 26.9038,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00A0FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.00657445,
  stopColor: "#00A1FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2601,
  stopColor: "#00BEFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5122,
  stopColor: "#00D2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7604,
  stopColor: "#00DFFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00E3FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg-public/img/nestleLanding/Google_Icon.svg__paint1_linear_976_15805",
  x1: 35.0126,
  y1: 18.6906,
  x2: -0.482725,
  y2: 18.6906,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4087,
  stopColor: "#FFBD00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7754,
  stopColor: "#FFA500"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF9C00"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg-public/img/nestleLanding/Google_Icon.svg__paint2_linear_976_15805",
  x1: 21.7961,
  y1: 22.0263,
  x2: -11.2849,
  y2: 55.4099,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF3A44"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C31162"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg-public/img/nestleLanding/Google_Icon.svg__paint3_linear_976_15805",
  x1: -3.91983,
  y1: -10.1243,
  x2: 10.8523,
  y2: 4.78276,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#32A071"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0685,
  stopColor: "#2DA771"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4762,
  stopColor: "#15CF74"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8009,
  stopColor: "#06E775"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00F076"
})))));
export { SvgGoogleIcon as ReactComponent };